import { gql } from "apollo-boost"

export default gql`
  mutation SubmitOrderCheckout($id: ID!, $deliveryType: DeliveryType!) {
    submitOrder(id: $id, deliveryType: $deliveryType) {
      id
      status
    }
  }
`
